import {UPDATE_EXTENSION} from "../actionTypes/screenshot.state.constant";

export const updateExtension = (extension) => ({
	type: UPDATE_EXTENSION,
	extension: extension
});
